const FORMSUBMIT_EMAIL = 'viczerga@gmail.com'

interface FormPayload {
  subject: string
  [key: string]: string | number | boolean | undefined
}

let iframeReady = false
let hiddenIframe: HTMLIFrameElement | null = null

function getOrCreateIframe(): HTMLIFrameElement {
  if (hiddenIframe && document.body.contains(hiddenIframe)) {
    return hiddenIframe
  }
  hiddenIframe = document.createElement('iframe')
  hiddenIframe.name = 'formsubmit-iframe'
  hiddenIframe.style.display = 'none'
  document.body.appendChild(hiddenIframe)
  iframeReady = true
  return hiddenIframe
}

export async function sendFormEmail(data: FormPayload): Promise<boolean> {
  return new Promise((resolve) => {
    try {
      const iframe = getOrCreateIframe()

      // Create a temporary form
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = `https://formsubmit.co/${FORMSUBMIT_EMAIL}`
      form.target = 'formsubmit-iframe'
      form.style.display = 'none'

      // Add all data fields as hidden inputs
      const allFields: Record<string, string> = {
        _captcha: 'false',
        _template: 'table',
        _next: window.location.href,
      }

      for (const [key, value] of Object.entries(data)) {
        if (value !== undefined && value !== null) {
          allFields[key] = String(value)
        }
      }

      for (const [key, value] of Object.entries(allFields)) {
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = key
        input.value = value
        form.appendChild(input)
      }

      document.body.appendChild(form)

      // Listen for iframe load to know submission completed
      const onLoad = () => {
        iframe.removeEventListener('load', onLoad)
        // Clean up the form
        if (form.parentNode) {
          form.parentNode.removeChild(form)
        }
        resolve(true)
      }

      iframe.addEventListener('load', onLoad)

      // Submit the form
      form.submit()

      // Fallback timeout in case load event doesn't fire
      setTimeout(() => {
        iframe.removeEventListener('load', onLoad)
        if (form.parentNode) {
          form.parentNode.removeChild(form)
        }
        resolve(true)
      }, 5000)
    } catch (err) {
      console.error('Form submission error:', err)
      resolve(false)
    }
  })
}
